import React from "react";
import { motion } from "framer-motion";

import Constants from "../../helpers/Constants";
import PictureImg from "../../helpers/PictureImg";

// ---------------------------------------------------------------------------
// Banner Section — Figma node 220:15375
//
// Two 960x960 panels side-by-side (1920x960 total):
//   ┌────────────────────┬────────────────────┐
//   │  멤버십통합 (blue)   │  포스 (gray)        │
//   │  image + dark scrim │  image + dark scrim │
//   │  white CTA pill     │  3 download images  │
//   └────────────────────┴────────────────────┘
//
// 우진 (2026-04-30): 포스 panel 의 단일 CTA 버튼이 AppStore / PlayStore /
// PC 다운로드 3개 이미지 버튼으로 변경됨 (Figma 490:8368). 멤버십 panel
// 은 기존 텍스트 CTA 유지.
// ---------------------------------------------------------------------------

const POS_DOWNLOAD_BUTTONS = [
  {
    src: "/img/ios.png",
    href: Constants.APPSTORE_URL,
    alt: "App Store에서 다운로드",
  },
  {
    src: "/img/android.png",
    href: Constants.PLAYSTORE_URL,
    alt: "Google Play에서 다운로드",
  },
  {
    src: "/img/window.png",
    href: Constants.PC_DOWNLOAD,
    alt: "Windows PC 다운로드",
  },
];

const BANNERS = [
  {
    key: "membership",
    title: "온·오프라인 멤버십을 통합해 보세요",
    desc: "상담을 신청하시면 전담 매니저가 브랜드에 맞는 최적의 솔루션을 안내해 드립니다.",
    cta: "도입 상담 신청하기",
    // 우진 (2026-04-30): 채널톡으로 연결. 외부 도메인 → 신규 탭.
    ctaHref: Constants.CHANNEL_TALK,
    bg: "/img/landing/banner-membership.png",
  },
  {
    key: "pos",
    title: "포스를 무료로 시작해 보세요",
    desc: "매장 규모와 운영 방식에 맞는 도입 방법을 무료 상담으로 안내드립니다.",
    bg: "/img/landing/banner-pos.png",
    images: POS_DOWNLOAD_BUTTONS,
  },
];

export default function Banner() {
  return (
    <section className="banner">
      {BANNERS.map((b, i) => (
        <motion.div
          key={b.key}
          className={`banner__panel banner__panel--${b.key}`}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="banner__panel-bg" aria-hidden="true">
            <PictureImg
              src={b.bg}
              alt=""
              loading="lazy"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </div>
          <div className="banner__panel-scrim" aria-hidden="true" />
          <div className="banner__text">
            <div className="banner__title-block">
              <h2 className="banner__title">{b.title}</h2>
              <p className="banner__desc">{b.desc}</p>
            </div>
            {b.images ? (
              <div className="banner__downloads">
                {b.images.map((img, j) => (
                  <a
                    key={j}
                    href={img.href}
                    className="banner__download"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={img.alt}
                  >
                    <PictureImg src={img.src} alt={img.alt} loading="lazy" />
                  </a>
                ))}
              </div>
            ) : (
              <a
                className="banner__cta"
                href={b.ctaHref}
                target="_blank"
                rel="noopener noreferrer"
              >
                {b.cta}
              </a>
            )}
          </div>
        </motion.div>
      ))}
    </section>
  );
}
